import styled from "styled-components";

export const OSAddonCont = styled.div`
  border-radius: 0.4rem;
  background-color: #ffffff;
  margin: 0 0 2rem 0;
`

export const OSAddonHeader = styled.div`
  font-family: 'Rubik';
  font-size: 1.8rem;
  font-weight: 600;
  padding-left: 3rem;
  padding-top: 14.5px;
  padding-bottom: 14.5px;
`

export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid #e4e4e4;
  margin: 0;
`;

export const CheckboxListCont = styled.div`
  display: flex;
  flex-direction:column;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 3rem 1rem;
  padding-right: 0;
`

export const CheckboxCont = styled.div`
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  padding-top:16px;
`

export const HrLine = styled.hr`
  border: none;
  border-top: 1px solid #e4e4e4;
  margin-top: 12px;
  margin-right: 12px;
`;